import { Badge, BadgeProps, tokens } from "@blurb/codex-react";
import { Box, createStyles } from "@mantine/core";
import { IconV3 } from "@rpi/openapi-core";
import { GraphQL } from "@rpi/openapi-api";
import React from "react";

type OrderItemBadgeColor = NonNullable<BadgeProps["color"]>;

const useStyles = createStyles(() => ({
  badgeWrapper: {
    display: "inline-flex",
    alignItems: "center",
  },
  icon: {
    fontVariationSettings: "'FILL' 1",
  },
}));

const getIconColor = (badgeColor: OrderItemBadgeColor): string => {
  const colorMap: Record<OrderItemBadgeColor, string> = {
    blue: tokens.color.primitive.light.blue[700],
    purple: tokens.color.primitive.light.purple[700],
    green: tokens.color.primitive.light.green[700],
    orange: tokens.color.primitive.light.yellow[800],
    red: tokens.color.primitive.light.red[700],
    white: tokens.color.primitive.light.gray[900],
    gray: tokens.color.primitive.light.gray[700],
  };

  return colorMap[badgeColor];
};

type OrderItemStatusConfig = Record<
  GraphQL.OrderItemStatus,
  {
    name: string;
    color: OrderItemBadgeColor;
  }
>;

const orderItemStatusConfig: OrderItemStatusConfig = {
  [GraphQL.OrderItemStatus.AwaitingProcessing]: {
    name: "Awaiting Processing",
    color: "blue",
  },
  [GraphQL.OrderItemStatus.Processing]: {
    name: "Processing",
    color: "orange",
  },
  [GraphQL.OrderItemStatus.ProcessingSuccess]: {
    name: "Processing Success",
    color: "green",
  },
  [GraphQL.OrderItemStatus.ProcessingFailed]: {
    name: "Processing Failed",
    color: "red",
  },
  [GraphQL.OrderItemStatus.PreflightSuccess]: {
    name: "Preflight Success",
    color: "green",
  },
};

interface OrderItemStatusCellProps {
  status?: GraphQL.OrderItemStatus | null;
}

export const OrderItemStatusCell: React.FC<OrderItemStatusCellProps> = ({ status }) => {
  const { classes } = useStyles();
  if (!status) return <></>;
  const config = orderItemStatusConfig[status];
  const iconColor = getIconColor(config.color);

  return (
    <Box className={classes.badgeWrapper}>
      <Badge
        label={config.name}
        color={config.color}
        variant="round"
        size="small"
        border={true}
        icon={<IconV3 icon="circle" size={12} color={iconColor} className={classes.icon} />}
      />
    </Box>
  );
};
